import * as React from "react";
import "./PropertyCard.scss";
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import { CurrConvertPrice } from '../currency-converter/CurrConvertPrice'
import imageConfig from "../../../static/images/config.json"
import PropertyIMG1 from "../../images/search-result/1.jpg";
import { useLocation } from "@reach/router"
import { Link } from "@StarberryUtils";
import { PhoneIconBlue, EnvelopeIconBlue, WhatsAppIconBlue } from  "../Icons/Icons";
const PropertyCardGrid = (props) => {

  const location = useLocation();
  var location_link = process.env.GATSBY_SITE_URL+location.pathname;

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  var whatsapp_link = `https://wa.me/971586234140?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
  if(location.search.indexOf("utm_source") > 0){
      whatsapp_link = `https://wa.me/971586234140?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
  }
  const formatNumberWithComma = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <React.Fragment>
      <div className="property-grid-card-wrap">
        <div className="properties-img-wrapper img-zoom">
            {
              props?.images && props?.images?.length != 0 ?
                <div className="properties-wrapper-rented">
                  {(props?.status == "Sold" || props?.status == "Rented") &&
                    <button className="btn btn-secondary tag-btn">{props.status}</button>
                  }
                  {props?.noResult ?
                    <img loading="lazy" src={props?.images[0]?.url} alt={`${props?.PropertyHeading} - Dacha`} />
                    :
                    <ShowProcessedImage images={props?.images[0]} attr={{ className: 'mb-0 img-fluid', alt: `${props?.PropertyHeading} banner - Dacha` }} transforms={imageConfig?.property?.searchResults1.sizes} />
                  }
                </div>
                :
                <div className="properties-wrapper-sold">
                  {(props?.status == "Sold" || props?.status == "Rented") &&
                    <button className="btn btn-secondary tag-btn">{props.status}</button>
                  }
                  <picture>
                    <img loading="lazy" src={PropertyIMG1} alt={`${props?.PropertyHeading} - Dacha`} />
                  </picture>
                </div>
            }

            <span className="sm-content d-md-none">{props?.OfferText}</span>
        </div>
        <div className="property-grid-card-info">
        <div className="properties-info">
          <h2 className="text-md-bold-20-16">
            {capitalizeFirstLetter(props?.PropertyHeading)} 
          </h2>
          <div className="price text-md-bold-20-16">
            {props?.poa === "Y" ?
              <span className="total">PRICE ON APPLICATION</span>
              :
              <span className="total">{CurrConvertPrice(props?.PropertyPrice.toLocaleString())} {(props?.tag == "for-rent") ? 'per year' : null}</span>
            }
          </div>
          <div className="about-location">
            <span><i className="icon-location"></i></span>
            <span className="location-info text-xs">
                {props?.PropertyAddress && (props?.PropertyAddress + ", ")}{props?.PropertyArea && (props?.PropertyArea + ", ")} {props?.PropertyTown && (props?.PropertyTown)}
            </span>
          </div>
          
            <div className="properties-icons">
              {props?.department == "residential" && props?.BedCount > 0 && (
                
                <div className="text">
                  <span><i className="icon-bedroom"></i></span>
                  <span className="text-xs-bold">{props?.BedCount}</span>
                </div>
              )}
             {props?.department == "residential" && props?.BathCount > 0 && (
                <div className="text">
                  <span><i className="icon-bath"></i></span>
                  <span className="text-xs-bold">{props?.BathCount}</span>
                </div>
              )}
              {props?.areaNumber !== 0 && (
                <div className="text">
                  <span><i className="icon-space"></i></span>
                  <span className="text-xs-bold">{props?.areaNumber ? formatNumberWithComma(props?.areaNumber) :''} sq.ft</span>
                </div>
              )}
            </div>
        </div>
        <div className="agent-contact-info">
            <a href={`tel:+971 4 423 2006`} className="agent-number text-xxs btn btn-light-blue">
                <span><PhoneIconBlue className="icon-contact-info" /></span>
                <span>Call</span>
            </a>
            <a href={'mailto:info@dacha.ae'} className="text-xxs btn btn-light-blue">
              <span><EnvelopeIconBlue className="icon-contact-info" /></span>
              <span>Email</span>
            </a>
          <Link href={whatsapp_link} className="text-xxs btn btn-light-blue" target="_blank">
            <span><WhatsAppIconBlue className="icon-contact-info" /></span>
            <span className="d-none d-xl-flex">WhatsApp</span>
          </Link>
        </div>
        </div>
      </div>
    </React.Fragment >
  );
};

export default PropertyCardGrid;